export default __webpack_public_path__ + "static/media/sportsbra-large-back-toobig.3fb86409.jpg";